import { render, staticRenderFns } from "./IvmApi.vue?vue&type=template&id=4334c920&lang=pug&"
import script from "./IvmApi.vue?vue&type=script&lang=ts&"
export * from "./IvmApi.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports